import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api.js";
import { useAuth } from "../context/AuthContext.jsx";
import AuthShell, { Campo, InputPassword, BotonPrimario, BotonSecundario, LineaError } from "../components/AuthShell.jsx";

/**
 * ResetPassword · v8.5.63 · piel — mismo marco AuthShell; sin token cae en
 * el estado "vencido" (línea --danger + secundario "Pedir uno nuevo"), con
 * token es el formulario reducido a mensaje + línea + una acción.
 */
export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const token = params.get("token");

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password !== confirm) { setError("Las contraseñas no coinciden"); return; }
    if (password.length < 8) { setError("Mínimo 8 caracteres"); return; }
    setSubmitting(true);
    try {
      const r = await api.resetPassword({ token, password_nueva: password });
      await loginWithToken(r.session_token, r.user, r.clientes);
      navigate(r.clientes?.length > 1 ? "/elegir-cliente" : "/", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <AuthShell>
        <h1 className="h1-portal text-[var(--danger)]">Link inválido</h1>
        <p className="text-[15px] text-[var(--muted)] mt-2">El link de reset no tiene token — pedí uno nuevo.</p>
        <div className="mt-6"><BotonSecundario href="/login">Pedir uno nuevo</BotonSecundario></div>
      </AuthShell>
    );
  }

  return (
    <AuthShell>
      <h1 className="h1-portal text-[var(--ink)]">Crear nueva contraseña</h1>
      <p className="text-[15px] text-[var(--muted)] mt-2">Mínimo 8 caracteres.</p>
      <form onSubmit={submit} className="mt-6 space-y-4">
        <Campo label="Nueva contraseña">
          <InputPassword value={password} onChange={setPassword} showPwd={showPwd} setShowPwd={setShowPwd} autoComplete="new-password" autoFocus/>
        </Campo>
        <Campo label="Confirmar contraseña">
          <InputPassword value={confirm} onChange={setConfirm} showPwd={showPwd} setShowPwd={setShowPwd} autoComplete="new-password"/>
        </Campo>
        {error && <LineaError msg={error}/>}
        <BotonPrimario submitting={submitting} disabled={!password || !confirm}>Cambiar contraseña</BotonPrimario>
      </form>
    </AuthShell>
  );
}
